import { RowValuesWithEcomodClass } from "../api/models/rowValues.models";

export interface DialogMaterial {
  key: string;
  label: string;
  materials: SimpleDialogMaterial[];
}

export interface SimpleDialogMaterial {
  key: string;
  label: string;
  econMaterials: EconDialogMaterial[];
  groupCategory?: GroupCategory;
  parentKey?: string;
}

export interface EconDialogMaterial {
  key: string;
  label: string;
  parentKey?: string;
}

export type DialogInputs = {
  ean: string;
  name: string;
  productNumber: string;
  reportId: number;
  values: RowValuesWithEcomodClass[];
  responsibleToReport: boolean;
  comment?: string;
};

// Fields shared between the product/model forms, lifted to a parent so they
// survive switching between the two forms.
export type BasicProductInfo = Pick<
  DialogInputs,
  "name" | "ean" | "productNumber" | "responsibleToReport" | "comment"
>;

export enum GroupCategory {
  CONSUMER,
  BUSINESS,
}

export const useMaterials = () => {
  const multiMaterialPackageCodes: string[] = [
    "1B1",
    "1B2",
    "1B3",
    "1B4",
    "1C1",
    "3B1",
    "3B2",
    "3B3",
    "3C1",
    "3C2",
    "2E2", // Useasta materiaalista valmistetut PVC/PVDC-pakkaukset
    "2C2", // Useasta materiaalista valmistetut yhdistelmäpakkaukset
  ];

  const businessOnlyMultimaterialPackageCodes: string[] = ["5A1", "5A2"];
  return { multiMaterialPackageCodes, businessOnlyMultimaterialPackageCodes };
};
